import { JsonObject, JsonProperty } from "typescript-json-serializer";


@JsonObject()
export class MaintenanceConfiguration {

    /**
     * Start displaying the maintenance information
     *
     * @example: "2020-11-20T07:00:00.000+01:00"
     */
    @JsonProperty()
    declare from: Date;

    /**
     * End displaying the maintenance information
     *
     * @example: "2020-11-27T18:30:00.000+01:00"
     */
    @JsonProperty()
    declare to: Date;

    /**
     * Message to display
     */
    @JsonProperty()
    declare message: string;

    constructor() {}
}
